import Api from './Api/index.ts';
import Services from './Services/index.ts';

class BelsoftCore {
  api: Api;
  services: Services;

  constructor() {
    this.api = new Api();
    this.services = new Services();
  }
}

const belsoftCore = new BelsoftCore();
export default belsoftCore;
